import React, { Component } from "react";
import GiftListConfigureWapModal from "../../../wapComponents/GiftListConfigureWapModal";
import commonUtil from "../../../../../../../utils/commonUtil";

class ImageOptionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isWap ? (
          <GiftListConfigureWapModal
            headerClassName="evnt-modal-header-giftList"
            titleClassName="evnt-modal-title-giftList"
            closeIconClassName="evnt-modal-close-icon-giftList"
            title={this.props.title}
            bodyClassName="evnt-modal-body-giftList custom-image-options-modal"
            closeModal={this.props.closeImageOptionsModal}
          >
            <div>
              <div className="image-menu-item" onClick={this.props.openCamera}>
                <img
                  src={
                    commonUtil.getAssetURL() + "/images/camera_alt_black.svg"
                  }
                  alt="Camera Alt"
                />{" "}
                <span className="image-menu-item-label">Camara</span>
              </div>
              <div className="image-menu-item-divider" />
              <div className="image-menu-item" onClick={this.props.openProfileImageUploader}>
                <img
                  src={commonUtil.getAssetURL() + "/images/photo_library.svg"}
                  alt="Photo Library"
                />{" "}
                <span className="image-menu-item-label">Galería</span>
              </div>
              <div className="image-menu-item-divider" />
              {this.props.isImageAdded && (
                <>
                  <div className="image-menu-item" onClick={this.props.deleteImage}>
                    <img
                      src={commonUtil.getAssetURL() + "/images/delete.svg"}
                      alt="Delete"
                    />{" "}
                    <span className="image-menu-item-label">Eliminar foto</span>
                  </div>
                </>
              )}
              <div className="image-menu-item-divider" />
            </div>
          </GiftListConfigureWapModal>
        ) : (
          <div
            ref={this.props.menuRef}
            className={
              this.props.title == "Imagen de portada"
                ? "image-popup-menu image-popup-menu-2"
                : "image-popup-menu"
            }
          >
            <div className="image-menu-item" onClick={this.props.openCamera}>
              <img
                src={commonUtil.getAssetURL() + "/images/camera_alt_black.svg"}
                alt="Camera Alt"
              />{" "}
              <span className="image-menu-item-label">Camara</span>
            </div>
            <div className="image-menu-item-divider" />
            <div className="image-menu-item" onClick={this.props.openProfileImageUploader}>
              <img
                src={commonUtil.getAssetURL() + "/images/file_upload.svg"}
                alt="File Upload"
              />{" "}
              <span className="image-menu-item-label">
                Subir desde mi computadora
              </span>
            </div>
            {this.props.isImageAdded && (
              <>
                <div className="image-menu-item-divider" />
                <div className="image-menu-item" onClick={this.props.deleteImage}>
                  <img
                    src={commonUtil.getAssetURL() + "/images/delete.svg"}
                    alt="Delete"
                  />{" "}
                  <span className="image-menu-item-label">Eliminar foto</span>
                </div>
              </>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default ImageOptionsModal;
